// extracted by mini-css-extract-plugin
export var chevron = "_ie-2";
export var dropdownItems = "_ie-0";
export var item = "_ie-1";